var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("DigitalEventController", [
    "$scope",
    "$rootScope",
    "$location",
    "eventsService",
    "$sce",
    "commonService",
    "favoritesService",
    function ($scope, $rootScope, $location, eventsService, $sce) {
        function getEventId() {
            if ($location.$$url != "") {
                alert("Invalid URL");
            }
            var url = $location.$$absUrl;
            if (url.toLowerCase().indexOf("eventid=") >= 0) {
                var key = url.toLowerCase().split("eventid=");
                if (key.length > 0) {
                    $scope.eventId = key[1];
                }
            }
        }
        getEventId();

        function getDigitalEventInfo() {
            $rootScope.showLoader = true;
            eventsService
                .getDigitalEventInfo($scope.eventId)
                .then(function (response) {
                    if (response) {
                        $rootScope.showLoader = false;
                        $scope.event = response.data;
                        $scope.eventName = response.data.eventName;
                        $scope.youtubeLink = $sce.trustAsResourceUrl(
                            response.data.youtubeLink
                        );
                        $scope.youtubeChatLink = $sce.trustAsResourceUrl(
                            response.data.chatLink
                        );
                        $scope.SaleHtmlContent = response.data.saleHtmlContent;
                        $scope.discountId = [];
                        var discountIds = response.data.discountId;
                        if (discountIds.indexOf(",") > -1)
                            $scope.discountId = discountIds.split(",");
                        else $scope.discountId = discountIds.split(" ");

                        getDigitalEventSaleItem();
                    }
                });
        }
        getDigitalEventInfo();

        function getDigitalEventSaleItem() {
            $rootScope.showLoader = true;
            angular.forEach($scope.discountId, function (discount,index) {
                eventsService
                    .getDigitalEventSaleItem(discount,$scope.eventId)
                    .then(function (response) {
                        if (response) {
                            $scope.sales[index] = response.data;
                        }
                    });
            });
        }
    },
]);
